import React, { useState } from 'react';
import { MapPin, Phone, Mail, Clock, Send, MessageCircle, Calendar, Building } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Textarea } from '../components/ui/textarea';
import { Badge } from '../components/ui/badge';
import { toast } from 'sonner';
import { Footer } from '../components/Footer';
import { CompactHeader } from '../components/CompactHeader';
export default function ContactPage() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    category: '',
    message: ''
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    toast.success('Message sent successfully! We will get back to you within 24 hours.');
    setFormData({
      name: '',
      email: '',
      phone: '',
      subject: '',
      category: '',
      message: ''
    });
  };

  const handleInputChange = (e) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  const offices = [
    {
      name: 'Lagos Island High Court Complex',
      address: 'Igbosere, Lagos Island, Lagos State',
      phone: '+234 92362 84623',
      email: 'island@lagosjudiciary.gov.ng',
      hours: 'Monday - Friday: 8:00 AM - 4:00 PM',
      services: ['High Court Civil Cases', 'High Court Criminal Cases', 'Court Registry', 'Legal Documentation']
    },
    {
      name: 'Ikeja High Court Complex',
      address: 'Alausa, Ikeja, Lagos State',
      phone: '+234 92362 84623',
      email: 'ikeja@lagosjudiciary.gov.ng',
      hours: 'Monday - Friday: 8:00 AM - 4:00 PM',
      services: ['Commercial Court', 'Family Court', 'Multi-Door Courthouse', 'E-Filing Center']
    },
    {
      name: 'Ikorodu Judicial Division',
      address: 'Ikorodu, Lagos State',
      phone: '+234 92362 84623',
      email: 'ikorodu@lagosjudiciary.gov.ng',
      hours: 'Monday - Friday: 8:00 AM - 4:00 PM',
      services: ['Magistrate Courts', 'Customary Courts', 'Family Matters', 'Local Registry']
    },
    {
      name: 'Badagry Judicial Division',
      address: 'Badagry, Lagos State',
      phone: '+234 92362 84623',
      email: 'badagry@lagosjudiciary.gov.ng',
      hours: 'Monday - Friday: 8:00 AM - 4:00 PM',
      services: ['Magistrate Courts', 'Customary Courts', 'Local Disputes', 'Community Justice']
    }
  ];

  const departments = [
    {
      name: 'IKEJA DIVISION',
      description: 'Oba Akinjobi way, Ikeja, Lagos State',
      contact: 'support@lagosjudiciary.gov.ng',
      hours: '08124777984'
    },
    {
      name: 'LAGOS DIVISION',
      description: 'Igbosere Road, Lagos Lagos State',
      contact: 'support@lagosjudiciary.gov.ng',
      hours: '08182052126, 08182052197'
    },
    {
      name: 'IKORODU DIVISION',
      description: '5, Owolowo Street, Opposite Ikorodu Town Hall, Ikorodu-Lagos,Lagos State',
      contact: 'supportt@lagosjudiciary.gov.ng',
      hours: '08172703282'
    },
    {
      name: 'EPE DIVISION',
      description: '87 Awolowo Way, Off Charlet Road, Oke-Oyinbo',
      contact: 'support@lagosjudiciary.gov.ng',
      hours: '08189493287'
    },
    {
      name: 'BADAGRY',
      description: 'G.R.A Road, Badagry, Lagos State',
      contact: 'support@lagosjudiciary.gov.ng',
      hours: '08182052064'
    },
    {
      name: 'ETI-OSA DIVISION',
      description: '2 Addo Rd, Ajah, Lekki, Lagos, Nigeria',
      contact: 'support@lagosjudiciary.gov.ng',
      hours: '08189493287'
    },
    {
      name: 'YABA-SURULERE DIVISION',
      description: '26 Birrel Street, Sabo Yaba, Lagos',
      contact: 'support@lagosjudiciary.gov.ng',
      hours: '08182052064'
    }
  ];

  const emergencyContacts = [
    {
      service: 'Court Security',
      number: '+234 92362 84623',
      description: 'Security emergencies within court premises'
    },
    {
      service: 'Urgent Case Matters',
      number: '+234 92362 84623',
      description: 'Time-sensitive legal matters requiring immediate attention'
    },
    {
      service: 'Technical Support',
      number: '+234 92362 84623',
      description: 'E-filing system emergencies and technical issues'
    }
  ];

  return (
    <div className="min-h-screen bg-white dark:bg-gray-900">
      <CompactHeader  />
      {/* Hero Section */}
      <section className="relative py-24 bg-hero-light-image dark:bg-hero-dark">
        
        <div className="container mx-auto px-4 sm:px-6 max-w-7xl relative z-10">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl md:text-6xl font-bold mb-6">
             Office of the Chief Judge
            </h1>
            <p className="text-xl md:text-2xl mb-8 leading-relaxed">
              We Would Love to Hear From You.
            </p>
            <div className="flex flex-wrap justify-center gap-4">
              <Badge variant="secondary" className="px-4 py-2 text-sm bg-white/20 border-white/30">
                <Phone className="w-4 h-4 mr-2" />
                +081 2477 7984
              </Badge>
              <Badge variant="secondary" className="px-4 py-2 text-sm bg-white/20 border-white/30">
                <Mail className="w-4 h-4 mr-2" />
                support@lagosjudiciary.gov.ng
              </Badge>
              <Badge variant="secondary" className="px-4 py-2 text-sm bg-white/20 border-white/30">
                <Clock className="w-4 h-4 mr-2" />
                Mon-Fri 8AM-4PM
              </Badge>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Form & Info */}
      <section className="py-20">
        <div className="container mx-auto px-4 sm:px-6 max-w-7xl">
          <div className="grid lg:grid-cols-2 gap-12">
            {/* Contact Form */}
            <div>
              <h2 className="text-3xl font-bold text-gray-900 dark:text-white mb-8">
                Send us a Message
              </h2>
              
              <Card className="border-0 shadow-lg">
                <CardContent className="p-8">
                  <form onSubmit={handleSubmit} className="space-y-6">
                    <div className="grid md:grid-cols-2 gap-4">
                      <div>
                        <Label htmlFor="name">Full Name *</Label>
                        <Input
                          id="name"
                          name="name"
                          value={formData.name}
                          onChange={handleInputChange}
                          required
                          placeholder="Enter your full name"
                          className="w-full mt-1 p-2 border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-800"
                        />
                      </div>
                      <div>
                        <Label htmlFor="email">Email Address *</Label>
                        <Input
                          id="email"
                          name="email"
                          type="email"
                          value={formData.email}
                          onChange={handleInputChange}
                          required
                          placeholder="Enter your email"
                          className="w-full mt-1 p-2 border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-800"
                        />
                      </div>
                    </div>

                    <div className="grid md:grid-cols-2 gap-4">
                      <div>
                        <Label htmlFor="phone">Phone Number</Label>
                        <Input
                          id="phone"
                          name="phone"
                          value={formData.phone}
                          onChange={handleInputChange}
                          placeholder="+234 XXX XXX XXXX"
                          className="w-full mt-1 p-2 border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-800"
                        />
                      </div>
                      <div>
                        <Label htmlFor="category">Inquiry Category *</Label>
                        <select
                          id="category"
                          name="category"
                          value={formData.category}
                          onChange={handleInputChange}
                          required
                          className="w-full mt-1 p-2 border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-800"
                        >
                          <option value="">Select category...</option>
                          <option value="case-inquiry">Case Inquiry</option>
                          <option value="filing-assistance">Filing Assistance</option>
                          <option value="technical-support">Technical Support</option>
                          <option value="legal-aid">Legal Aid</option>
                          <option value="court-scheduling">Court Scheduling</option>
                          <option value="general-inquiry">General Inquiry</option>
                          <option value="media-request">Media Request</option>
                          <option value="complaint">Complaint</option>
                        </select>
                      </div>
                    </div>

                    <div>
                      <Label htmlFor="subject">Subject *</Label>
                      <Input
                        id="subject"
                        name="subject"
                        value={formData.subject}
                        onChange={handleInputChange}
                        required
                        placeholder="Brief subject of your inquiry"
                        className="w-full mt-1 p-2 border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-800"
                      />
                    </div>

                    <div>
                      <Label htmlFor="message">Message *</Label>
                      <Textarea
                        id="message"
                        name="message"
                        value={formData.message}
                        onChange={handleInputChange}
                        required
                        rows={6}
                        placeholder="Please provide details about your inquiry..."
                      />
                    </div>

                    <Button type="submit" size="lg" className="w-full">
                      <Send className="h-4 w-4 mr-2" />
                      Send Message
                    </Button>
                  </form>
                </CardContent>
              </Card>
            </div>

            {/* Contact Information */}
            <div>
              <h3 className="text-2xl font-bold text-gray-900 dark:text-white mb-8">
                Get in Touch
              </h3>

              {/* Quick Contact */}
              <Card className="border-0 shadow-lg mb-8">
                <CardContent className="p-6">
                  <div className="space-y-4">
                    <div className="flex items-center space-x-3">
                      <Phone className="h-5 w-5 text-blue-600" />
                      <div>
                        <p className="font-medium text-gray-900 dark:text-white">Phone</p>
                        <p className="text-gray-600 dark:text-gray-400">+08124777984</p>
                      </div>
                    </div>

                    <div className="flex items-center space-x-3">
                      <Mail className="h-5 w-5 text-blue-600" />
                      <div>
                        <p className="font-medium text-gray-900 dark:text-white">Email</p>
                        <p className="text-gray-600 dark:text-gray-400">support@lagosjudiciary.gov.ng</p>
                      </div>
                    </div>

                    <div className="flex items-center space-x-3">
                      <MapPin className="h-5 w-5 text-blue-600" />
                      <div>
                        <p className="font-medium text-gray-900 dark:text-white">Main Office</p>
                        <p className="text-gray-600 dark:text-gray-400">
                          Oba Akinjobi Way<br />
                          Lagos Island, Ikeja, Lagos
                        </p>
                      </div>
                    </div>

                    <div className="flex items-center space-x-3">
                      <Clock className="h-5 w-5 text-blue-600" />
                      <div>
                        <p className="font-medium text-gray-900 dark:text-white">Office Hours</p>
                        <p className="text-gray-600 dark:text-gray-400">
                          Monday - Friday: 8:00 AM - 4:00 PM<br />
                          Saturday - Sunday: Closed
                        </p>
                      </div>
                    </div>
                  </div>
                </CardContent>
              </Card>

              {/* Emergency Contacts */}
              <Card className="border-0 shadow-lg">
                <CardHeader>
                  <CardTitle className="flex items-center">
                    <MessageCircle className="h-5 w-5 mr-2 text-red-600" />
                    Emergency Contacts
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <div className="space-y-3">
                    {emergencyContacts.map((contact, index) => (
                      <div key={index} className="p-3 bg-red-50 dark:bg-red-900/20 rounded-lg">
                        <div className="flex justify-between items-start">
                          <div>
                            <p className="font-medium text-gray-900 dark:text-white">{contact.service}</p>
                            <p className="text-sm text-gray-600 dark:text-gray-400">{contact.description}</p>
                          </div>
                          <a href={`tel:${contact.number}`} className="text-red-600 font-medium text-sm hover:underline">
                            {contact.number}
                          </a>
                        </div>
                      </div>
                    ))}
                  </div>
                </CardContent>
              </Card>
            </div>
          </div>
        </div>
      </section>

      {/* Office Locations 
      <section className="py-20 bg-gray-50 dark:bg-gray-800">
        <div className="container mx-auto px-4 sm:px-6 max-w-7xl">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 dark:text-white mb-4">
              Our Locations
            </h2>
            <p className="text-xl text-gray-600 dark:text-gray-400">
              Visit us at our various court complexes across Lagos State
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8">
            {offices.map((office, index) => (
              <Card key={index} className="border-0 shadow-lg">
                <CardHeader>
                  <CardTitle className="flex items-center">
                    <Building className="h-5 w-5 mr-2 text-blue-600" />
                    {office.name}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <div className="space-y-4">
                    <div className="flex items-start space-x-3">
                      <MapPin className="h-4 w-4 text-gray-600 mt-1 flex-shrink-0" />
                      <p className="text-gray-600 dark:text-gray-400">{office.address}</p>
                    </div>

                    <div className="flex items-center space-x-3">
                      <Phone className="h-4 w-4 text-gray-600 flex-shrink-0" />
                      <a href={`tel:${office.phone}`} className="text-blue-600 hover:underline">
                        {office.phone}
                      </a>
                    </div>

                    <div className="flex items-center space-x-3">
                      <Mail className="h-4 w-4 text-gray-600 flex-shrink-0" />
                      <a href={`mailto:${office.email}`} className="text-blue-600 hover:underline">
                        {office.email}
                      </a>
                    </div>

                    <div className="flex items-center space-x-3">
                      <Clock className="h-4 w-4 text-gray-600 flex-shrink-0" />
                      <p className="text-gray-600 dark:text-gray-400">{office.hours}</p>
                    </div>

                    <div>
                      <h4 className="font-medium text-gray-900 dark:text-white mb-2">Services Available:</h4>
                      <div className="flex flex-wrap gap-2">
                        {office.services.map((service, serviceIndex) => (
                          <Badge key={serviceIndex} variant="outline" className="text-xs">
                            {service}
                          </Badge>
                        ))}
                      </div>
                    </div>

                    <Button variant="outline" size="sm" className="w-full">
                      <MapPin className="h-4 w-4 mr-2" />
                      Get Directions
                    </Button>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>
*/}
      {/* Department Contacts */}
      <section className="py-8 bg-gray-50 dark:bg-gray-800">
        <div className="container mx-auto px-4 sm:px-6 max-w-7xl py-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 dark:text-white mb-4">
              JIS Support
            </h2>
            <p className="text-xl text-gray-600 dark:text-gray-400">
              Direct contacts for specific support
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {departments.map((dept, index) => (
              <Card key={index} className="border-0 shadow-lg">
                <CardContent className="p-6">
                  <h3 className="font-bold text-gray-900 dark:text-white mb-2">
                    {dept.name}
                  </h3>
                  <p className="text-sm text-gray-600 dark:text-gray-400 mb-4 leading-relaxed">
                    {dept.description}
                  </p>
                  <div className="space-y-2">
                    <div className="flex items-center space-x-2">
                      <Mail className="h-4 w-4 text-blue-600" />
                      <a href={`mailto:${dept.contact}`} className="text-blue-600 hover:underline text-sm">
                        {dept.contact}
                      </a>
                    </div>
                    <div className="flex items-center space-x-2">
                      <Phone className="h-4 w-4 text-gray-600" />
                      <span className="text-gray-600 dark:text-gray-400 text-sm">{dept.hours}</span>
                    </div>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

     {/* <section className="py-20 bg-blue-600 text-white">
        <div className="container mx-auto px-4 sm:px-6 max-w-7xl text-center">
          <h2 className="text-3xl font-bold mb-6">
            Need Immediate Assistance?
          </h2>
          <p className="text-xl text-blue-100 mb-8 max-w-2xl mx-auto">
            Check our frequently asked questions or schedule a consultation with our staff
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <Button variant="secondary" size="lg">
              <Calendar className="h-4 w-4 mr-2" />
              Schedule Consultation
            </Button>
            <Button variant="outline" size="lg" className="border-white text-white hover:bg-white hover:text-blue-600">
              View FAQ
            </Button>
          </div>
        </div>
      </section> */}
       <Footer />
    </div>
  );
}